import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { CursPage } from './pages/CursPage';
import { CursAbcPage } from './pages/CursAbcPage';
import { TraiestePage } from './pages/TraiestePage';
import { IubirePage } from './pages/IubirePage';
import { DeschidePage } from './pages/DeschidePage';
import { ArtaPage } from './pages/ArtaPage';
import { ColectiePage } from './pages/ColectiePage';
import { MagazinPage } from './pages/MagazinPage';
import { Oferta1la1Page } from './pages/Oferta1la1Page';
import { WorkshopPage } from './pages/WorkshopPage';
import { CadouPage } from './pages/CadouPage';
import { DespreminePage } from './pages/DespreminePage';
import { ContactPage } from './pages/ContactPage';
import { TestimonialePage } from './pages/TestimonialePage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/cursmagnet" element={<CursPage data-id="element-5" />} data-id="element-4" />
        <Route path="/cursabc" element={<CursAbcPage data-id="element-7" />} data-id="element-6" />
        <Route path="/curstraieste" element={<TraiestePage data-id="element-9" />} data-id="element-8" />
        <Route path="/cursiubire" element={<IubirePage data-id="element-11" />} data-id="element-10" />
        <Route path="/cursabundentaiubirii" element={<IubirePage data-id="element-13" />} data-id="element-12" />
        <Route path="/cursdeschide" element={<DeschidePage data-id="element-15" />} data-id="element-14" />
        <Route path="/arta" element={<ArtaPage data-id="element-17" />} data-id="element-16" />
        <Route path="/cursarta" element={<ArtaPage data-id="element-19" />} data-id="element-18" />
        <Route path="/colectie" element={<ColectiePage data-id="element-21" />} data-id="element-20" />
        <Route path="/academia" element={<ColectiePage data-id="element-23" />} data-id="element-22" />
        <Route path="/magazin" element={<MagazinPage data-id="element-25" />} data-id="element-24" />
        <Route path="/oferta1la1" element={<Oferta1la1Page data-id="element-27" />} data-id="element-26" />
        <Route path="/workshop" element={<WorkshopPage data-id="element-29" />} data-id="element-28" />
        <Route path="/resurse-gratuite" element={<WorkshopPage data-id="element-31" />} data-id="element-30" />
        <Route path="/cadou" element={<CadouPage data-id="element-33" />} data-id="element-32" />
        <Route path="/sesiune-cadou" element={<CadouPage data-id="element-35" />} data-id="element-34" />
        <Route path="/despremine" element={<DespreminePage data-id="element-37" />} data-id="element-36" />
        <Route path="/despre-mine" element={<DespreminePage data-id="element-39" />} data-id="element-38" />
        <Route path="/contact" element={<ContactPage data-id="element-41" />} data-id="element-40" />
        <Route path="/testimoniale" element={<TestimonialePage data-id="element-43" />} data-id="element-42" />
      </Routes>
    </BrowserRouter>;
}